import api from "../api";
import loginService from "../login.service";
import documentsService from "../solicitation/documents.service";
import { buildRequestFilter } from "../../../components/providers/utils.provider";
import { uploadThroughEngine } from '../solicitation/documents.engine';

export const findAll = async (filters = {}, pagination) => {

    const filter = buildRequestFilter(filters);

    return api.post({
        type: "user",
        service: `marketing/blog/filter`,
        data: {
            filter,
            pagination,
        }
    })
        .then(res => res.data || {});
}

export const findMetrics = async (filters = {}) => {

    const filter = buildRequestFilter(filters);

    return api.post({
        type: "user",
        service: `marketing/blog/metrics`,
        data: {
            filter,
        }
    })
        .then(res => res.data || []);
}

export const findConversions = async (filters = {}) =>
    api.post({ type: "user", service: `marketing/blog/conversions`, data: { filter: buildRequestFilter(filters) } })
        .then(res => res.data || {});

export const findById = async (id) =>
    api.get({ type: "user", service: `marketing/blog/${id}` })
        .then(res => (res.data || {}));

export const findBySlug = async (slug) =>
    api.get({ type: "user", service: `marketing/blog/slug/${slug}` })
        .then(res => (res.data || null));

export const findBlogTags = async () =>
    api.get({ type: "user", service: `marketing/blog/tags` })
        .then(res => (res.data || []));

export const findBlogAuthors = async () =>
    api.get({ type: "user", service: `marketing/blog/authors` })
        .then(res => (res.data || []));

export const createNewBlog = async () => {

    const user = loginService.getUserAuthentication();

    const initialBlogConfig = {
        title: 'Novo Artigo',
        status: 'draft',
        userId: user.id,
        authorUserId: user.id,
    };

    return api.post({ type: "user", service: `marketing/blog/`, data: initialBlogConfig })
        .then(res => res.data || { success: false });
}

export const edit = async (id, blogChanges) =>
    api.put({
        type: "user",
        service: `marketing/blog/${id}`,
        data: mapValues(blogChanges),
    });

const mapValues = (data) => ({
    title: data.title,
    content: data.content,
    status: data.status,
    headerCta: data.headerCta,
    footerBanner: data.footerBanner,
    tags: data.tags ? JSON.stringify(data.tags) : undefined,
    readingTime: data.readingTime,
    published: data.published,
    ebook: data.ebook,
    slug: data.slug,
    seoInformation: data.seoInformation,
    deleted: data.deleted,
    authorUserId: data.authorUserId,
    verticalBanner: data.verticalBanner,
});

const createImageEntry = async (fileData, blogId, type) =>
    api.post({ type: 'user', service: `marketing/blog/${blogId}/blog-image`, data: { file: fileData, type } })
        .then(({ data }) => data);

const imageConfigByType = {
    cover: {
        key: 'coverImage',
        label: 'Imagem de Capa',
    },
    verticalBanner: {
        key: 'verticalBanner',
        label: 'Imagem do Banner Vertical',
    },
}

const updateBlogImage = async (file, blogId, type) => {

    const imageConfig = imageConfigByType[type];

    const viaEngine = await uploadThroughEngine({ files: [file], targetKind: 'blogImage', targetOf: () => ({ blogId, type }) });
    if (viaEngine) return { success: true, ...viaEngine[0].result };

    const fileData = {
        name: file.name,
        size: file.size,
        fileType: file.type
    };

    const response = await createImageEntry(fileData, blogId, type).catch(() => { });

    if (!response.success) throw Error({ message: response.message || 'Ocorreu um problema, por favor tente novamente mais tarde' });

    const upload = await documentsService.uploadFile(file, response.signedRequest, { ...fileData, document: { name: fileData.name } });

    if (!upload.success) {
        return { success: false };
    }

    return { success: true, [imageConfig.key]: response[imageConfig.key] };
}

const findVerticalBanners = async () =>
    api
        .get({ type: "user", service: `marketing/blog/vertical-banners` })
        .then(res => (res.data || []));

const BlogsService = {
    findAll,
    findById,
    findBySlug,
    createNewBlog,
    edit,
    findBlogTags,
    findBlogAuthors,
    findMetrics,
    updateBlogImage,
    findVerticalBanners,
    imageConfigByType,
    findConversions,
}

export default BlogsService;
